export default {
  coinName: "HBAR",
  coinNameX: "HBARX",
};
